// extracted by mini-css-extract-plugin
export default {"container":"countdown_container__pfnWt","small_view":"countdown_small_view__3mGIF"};